<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="앨범 조회"
      desc="등록한 앨범들의 현황을 조회할 수 있습니다."
    >
      <lp-adm-drop-input slot="group_category"
                         :data.sync="cats"
                         :selectVal="selectedGroup"
                         @onSelect="selectCategory"
                         placeholder="팀 선택"
                         width="160px"
                         listAlign="center"
                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
    </admin-filter>

    <div class="btn-group-justify-end">
      <button @click="clickReg" class="button is-primary">앨범 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <div @click="detailLink(props)">{{ props.item.name }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import GroupMixin from "@/mixins/GroupMixin"
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: 'AlbumList',
    layout:'Main',
    mixins: [
      ListMixin,
      GroupMixin
    ],
    components: {
      LpAdmDropInput

    },
    data () {
      return {
        cats: [],
        selectedGroup: '',
      }
    },
    created() {
    },
    methods: {
      init() {
        this.initializing('group_album', 'group/album');
        this.filtered.group = '';
        this.getGroupList('cats', true);
      },
      getDataFromServer() {
        this.getData();
      },
      clickReg() {
        let query = '';
        if(this.filtered.group!=='') {
          query = '?group_id=' + this.filtered.group;
        }
        this.$router.push('album/create'+query);
      },
      selectCategory(e) {
        if(e.value === '') {
          delete this.filtered.group;
          this.selectedGroup = '';
        }

        else {
          this.filtered.group = e.value;
          this.selectedGroup = e.label;
        }

        this.getData();
      },
      detailLink(props) {
        let group_id = props.item.group;
        let album_id = props.item.id;

        this.$router.push(`album/post?group_id=${group_id}&album_id=${album_id}`);
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`group/album/create?group_id=${item.group}&album_id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `group/${item.group}/album/${item.id}`,
            title: '앨범을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'


</style>
